var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"cabecalho",attrs:{"id":"home"}},[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:( {
            el: '#home',  
            container: 'body', 
            duration: 500, 
            lazy: false,
            easing: 'ease-in-out', 
            offset: -5, 
            force: true , 
            cancelable: true,
            onStart: false,
            onDone: false,
            onCancel: false, 
            x: false, 
            y: true,
        } ),expression:" {\n            el: '#home',  \n            container: 'body', \n            duration: 500, \n            lazy: false,\n            easing: 'ease-in-out', \n            offset: -5, \n            force: true , \n            cancelable: true,\n            onStart: false,\n            onDone: false,\n            onCancel: false, \n            x: false, \n            y: true,\n        } "}],attrs:{"id":"home","href":"home"}},[_c('img',{attrs:{"src":require("../assets/logo.webp"),"alt":""}})]),_c('nav',{staticClass:"menu"},[_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:( {
            el: '#home',  
            container: 'body', 
            duration: 500, 
            lazy: false,
            easing: 'ease-in-out', 
            offset: -5, 
            force: true , 
            cancelable: true,
            onStart: false,
            onDone: false,
            onCancel: false, 
            x: false, 
            y: true,
        } ),expression:" {\n            el: '#home',  \n            container: 'body', \n            duration: 500, \n            lazy: false,\n            easing: 'ease-in-out', \n            offset: -5, \n            force: true , \n            cancelable: true,\n            onStart: false,\n            onDone: false,\n            onCancel: false, \n            x: false, \n            y: true,\n        } "}],attrs:{"href":"home"}},[_vm._v("Home")])]),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:( { 
            el: '#sobre', 
            container: 'body', 
            duration: 500, 
            lazy: false,
            easing: 'ease-in-out', 
            offset: -5, 
            force: true , 
            cancelable: true,
            onStart: false,
            onDone: false,
            onCancel: false, 
            x: false, 
            y: true,
        } ),expression:" { \n            el: '#sobre', \n            container: 'body', \n            duration: 500, \n            lazy: false,\n            easing: 'ease-in-out', \n            offset: -5, \n            force: true , \n            cancelable: true,\n            onStart: false,\n            onDone: false,\n            onCancel: false, \n            x: false, \n            y: true,\n        } "}],attrs:{"href":"#sobre"}},[_vm._v("Sobre")])]),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:( { 
            el: '#skills', 
            container: 'body', 
            duration: 1000, 
            lazy: false,
            easing: 'ease-in-out', 
            offset: -150, 
            force: true , 
            cancelable: true,
            onStart: false,
            onDone: false,
            onCancel: false,
            x: false, 
            y: true 
        } ),expression:" { \n            el: '#skills', \n            container: 'body', \n            duration: 1000, \n            lazy: false,\n            easing: 'ease-in-out', \n            offset: -150, \n            force: true , \n            cancelable: true,\n            onStart: false,\n            onDone: false,\n            onCancel: false,\n            x: false, \n            y: true \n        } "}],attrs:{"href":"#skills"}},[_vm._v(" Skills ")])]),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:( { 
            el: '#jobs', 
            container: 'body', 
            duration: 500, 
            lazy: false,
            easing: 'ease-in-out', 
            offset: -120, 
            force: true , 
            cancelable: true,
            onStart: false,
            onDone: false,
            onCancel: false,
            x: false, 
            y: true 
        } ),expression:" { \n            el: '#jobs', \n            container: 'body', \n            duration: 500, \n            lazy: false,\n            easing: 'ease-in-out', \n            offset: -120, \n            force: true , \n            cancelable: true,\n            onStart: false,\n            onDone: false,\n            onCancel: false,\n            x: false, \n            y: true \n        } "}],attrs:{"href":"#jobs"}},[_vm._v(" Jobs ")])]),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://abisaiweb7.medium.com/","target":"_blank"}},[_vm._v("Blog")])])}]

export { render, staticRenderFns }